class SearchModal extends HTMLElement {
  constructor() {
    super();
    this.trigger = this.querySelector('.ff-search-trigger');
    this.modal = this.querySelector('.ff-search-modal');
    this.overlay = this.querySelector('.ff-search-modal__overlay');
    this.closeButton = this.querySelector('.ff-search-modal__close-button');
    this.isOpen = false;
    this.scrollPosition = 0;

    this.trigger.addEventListener('click', this.open.bind(this));
    this.closeButton.addEventListener('click', this.close.bind(this));
    this.overlay.addEventListener('click', this.close.bind(this));
    
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen) this.close();
    });

    // Bound function para poder remover el listener correctamente
    this.ffPreventTouchMove = this.preventTouchMove.bind(this);
  }

  preventTouchMove(e) {
    // Permitir scroll solo dentro del contenedor de búsqueda predictiva
    const scrollableArea = e.target.closest(".ff-predictive-search");
    if (!scrollableArea) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  }

  lockScroll() {
    this.scrollPosition = window.pageYOffset;
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${this.scrollPosition}px`;
    document.body.style.width = '100%';
  }

  unlockScroll() {
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo({
      top: this.scrollPosition,
      behavior: 'instant'
    });
  }

  open() {
    if (this.isOpen) return;
    
    this.isOpen = true;
    this.lockScroll();
    this.modal.style.display = 'flex';
    this.modal.offsetHeight; // Forzar reflow
    this.modal.classList.add('open');
    this.overlay.classList.add('show');

    // Agregar listeners para prevenir scroll en iOS
    document.addEventListener("touchmove", this.ffPreventTouchMove, { passive: false });

    const input = this.modal.querySelector('input[type="search"]');
    if (input) setTimeout(() => input.focus(), 100);
  }

  close() {
    if (!this.isOpen) return;
    
    this.isOpen = false;
    this.modal.classList.remove('open');
    this.modal.classList.add('closing');
    this.overlay.classList.remove('show');
    
    // Remover listeners
    document.removeEventListener("touchmove", this.ffPreventTouchMove, { passive: false });
    
    setTimeout(() => {
      this.modal.classList.remove('closing');
      this.modal.style.display = 'none';
    }, 300);
    
    this.unlockScroll();
  }
}

customElements.define('ff-details-modal', SearchModal);
